import dataManagement from './modules/dataManagement';
// import typicalmanagement from './modules/typicalmanagement/index';
//
const models = {
  dataManagement
};

function model(modelName) {
  return new models[modelName]();
}
model.install = function (Vue) {
  Vue.prototype.$model = model;
  Vue.model = model;
};
export default model;



// WEBPACK FOOTER //
// ./src/model/index.js